import { publishUserQueries } from '@/entities/sets/publish';
import { loginApi } from '@/shared/api/login';
import { useLoginStore, usePersistStore, commonQueries } from '@/shared/lib/store';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { sendTraceLog } from '@/shared/log/tracker';
import ErrorPopup from '@/shared/publish/Homework/ErrorPopup';
import { showToast } from '@/shared/utils/toast';
import { initTokenManager, resetToken } from '@/shared/utils/wait-for-token';
import { useRouter } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

export const LoginCheck = () => {
    const router = useRouter();
    const { loginInfo, memberInfo, setLoginInfo, getMemberInfo } = useLoginStore();
    const {
        setPersistToken,
        setSUserId,
        setSDefaultUserId,
        setSIsLogin,
        setSSchCode,
        setSBrandId,
        setSAuthLogin,
        sToken,
        sVivaToken,
        setSMyClassMemberList,
        classMemberListRefreshTrigger,
    } = usePersistStore();

    const registerStudent = publishUserQueries.postRegisterUser();
    const { showModal, closeModal } = useModalStore();
    const isHomeowrk =
        location.pathname.toLowerCase().includes('eval') ||
        location.pathname.toLowerCase().includes('homework');

    const isTchReport = location.pathname.toLowerCase().includes('report/eval/t');
    const params = new URLSearchParams(location.search);
    const direct = params.get('direct');
    const isDirect = direct === 'y';
    const isStntReport = location.pathname.toLowerCase().includes('report/eval/s') && isDirect;
    const isImportHeader = location.pathname.toLocaleLowerCase().includes('edit');
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

    const { data } = commonQueries.getSessionInfo(
        isImportHeader || !isHomeowrk || isTchReport || isStntReport
    );

    const setToken = (jwt: any) => {
        if (jwt) {
            setPersistToken(jwt);
        }
    };

    const loginCheck = async (data: API.SessionIfo.Res) => {
        const type = typeof data;
        if (type == 'string') {
            setLoginInfo({ loginYn: 'Y' });
        } else {
            if (data) {
                initTokenManager();

                const login: any = data;
                // login.schCode = 'ES';
                setLoginInfo(login);
                const param = {
                    timestamp: Date.now().toString(),
                    id: 'sbank',
                };

                const jwt = await loginApi.createJwtToken(param);

                setToken(jwt);
            } else {
                setLoginInfo({
                    memberId: '',
                    name: '',
                    schCode: '',
                    cellphone: '',
                    sessionId: '',
                    loginYn: 'P',
                    teacherYn: 'N',
                    studentYn: 'N',
                    schClassNo: '',
                    email: '',
                    pwd: '',
                    state: '',
                    lastDttm: 0,
                    lastIp: '',
                    smsYn: '',
                    emailYn: '',
                    pwdExpiredDt: '',
                    regAdminId: '',
                    regDttm: 0,
                    udtAdminId: '',
                    udtDttm: 0,
                    memberType: '',
                    memberExpiredDt: '',
                });
                if (!isDirect) {
                    window.location.href = '/create';
                }
                resetToken();
            }
        }
    };

    useEffect(() => {
        if (loginInfo.loginYn === 'Y') {
            afterLoginPersistSetup();
            getMemberInfo();
        } else if (loginInfo.loginYn === 'N') {
            if (!location.pathname.includes('create')) {
                !isDirect && router.navigate({ to: '/create' });
            }
        }
    }, [loginInfo.loginYn]);

    const afterLoginPersistSetup = () => {
        setSUserId();
        setSDefaultUserId();
        setSIsLogin();
        setSSchCode();
        setSAuthLogin({
            // id: loginInfo.memberId,
            id: 'vivaclass',
            accessKey: import.meta.env.VITE_VIVACLASS_ACCESS_KEY,
        });
    };

    useEffect(() => {
        sendTraceLog('', '', '', 'debug', '[SBANK_LOG] LoginInfo = ', data);
        if (data && data?.data) {
            setLoginInfo(data?.data);

            if (data?.data.loginYn === 'Y') {
                loginCheck(data?.data);
            } else {
                sessionStorage.removeItem('persist-token');
                resetToken();
                if (!location.pathname.includes('create')) {
                    !isDirect && router.navigate({ to: '/create' });
                }
            }
        }
    }, [data]);

    useEffect(() => {
        afterTokenClassSetup();
    }, [sVivaToken, loginInfo.memberId, classMemberListRefreshTrigger]);

    useEffect(() => {
        if (
            sToken &&
            loginInfo.loginYn == 'Y' &&
            loginInfo?.memberId &&
            (memberInfo.typeCode === '0' ||
                memberInfo.typeCode === '1' ||
                memberInfo.typeCode === '2')
        ) {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
            debounceTimerRef.current = setTimeout(() => {
                registerStudent.mutate(
                    {
                        tcUserId: loginInfo?.memberId ? 'viva-' + loginInfo?.memberId + '-t' : '',
                        claList: [],
                    },
                    {
                        onSuccess: (res) => {
                            if (res?.resultOk) {
                                sendTraceLog(
                                    '',
                                    '',
                                    '',
                                    'debug',
                                    '[SBANK_LOG] 회원 정보 등록 성공 = ',
                                    res
                                );
                            } else showToast('회원 정보 등록 실패', 2000, 'error');
                        },
                        onError: () =>
                            showModal({
                                isCustom: true,
                                id: 'error',
                                initContents: () => <ErrorPopup />,
                            }),
                    }
                );
            }, 300);
        }
    }, [sToken, memberInfo]);

    const afterTokenClassSetup = () => {
        if (!!sVivaToken && !!loginInfo.memberId) {
            setSMyClassMemberList({ teacherId: loginInfo.memberId, validYn: 'N' }, sVivaToken);
        }
    };

    return <></>;
};
